import { PDFViewer } from "@react-pdf/renderer"
import React, { useState } from "react"
import { Card, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import EndButton from "../EndButton"
import NewPDF from "./DocumentMaker"
import styles from "./EndGameBar.module.scss"

function EndGameBar({ penaltiesOrEnd, onLeave, pdfData, sport, events }) {
	const [isPDFOpen, setIsPDFOpen] = useState(false)
	const spectate = localStorage.getItem("spectate")

	if (penaltiesOrEnd !== "done" && !spectate) {
		if (penaltiesOrEnd === "forfeit") {
			const { isHome, isAway } = JSON.parse(
				localStorage.getItem("forfeitBody") ?? "{}"
			)
			let message = "Obe ekipe su se predale"
			if (isHome && !isAway) {
				const name = JSON.parse(
					localStorage.getItem("homeTeam") ?? "{}"
				).name
				message = `Ekipa ${name} se predala`
			} else if (!isHome && isAway) {
				const name = JSON.parse(
					localStorage.getItem("awayTeam") ?? "{}"
				).name
				message = `Ekipa ${name} se predala`
			}

			return (
				<Card>
					<div className={styles.wrapper}>
						<span></span>
						<h1>Predaja</h1>
						<EndButton penaltiesOrEnd={penaltiesOrEnd} />
					</div>
					<h3 className="text-center mb-2">{message}</h3>
				</Card>
			)
		}
		return (
			<Card className={styles.wrapper}>
				<span></span>
				<h1>
					{penaltiesOrEnd === "penalties" ? "Penali" : "Završni pregled"}
				</h1>
				<EndButton penaltiesOrEnd={penaltiesOrEnd} />
			</Card>
		)
	}

	return (
		<Card className={styles.wrapper}>
			{!spectate ? (
				<Button.Ripple
					color="primary"
					outline
					onClick={() => setIsPDFOpen(true)}
				>
					PDF
				</Button.Ripple>
			) : (
				<span></span>
			)}

			<Modal
				className="modal-dialog-centered"
				isOpen={isPDFOpen}
				toggle={() => setIsPDFOpen(false)}
			>
				<ModalHeader toggle={() => setIsPDFOpen(false)}>
					Preuzmi PDF dokument
				</ModalHeader>
				{isPDFOpen && (
					<ModalBody>
						<p>
							Utakmica je gotova, dali želite preuzeti PDF dokument kao
							preglednik ove utakmice.
						</p>
						<PDFViewer
							style={{
								border: "none",
								width: "100%",
								height: "50vh",
							}}
						>
							<NewPDF sport={sport} data={pdfData} events={events} />
						</PDFViewer>
					</ModalBody>
				)}
				<ModalFooter>
					<Button.Ripple
						color="secondary"
						outline
						onClick={() => setIsPDFOpen(false)}
					>
						Zatvori
					</Button.Ripple>
				</ModalFooter>
			</Modal>
			<h1>{penaltiesOrEnd === "penalties" ? "Penali" : "Završni pregled"}</h1>
			{
			  !spectate && 
				<Button.Ripple color="primary" outline onClick={onLeave}>
				Izađi iz utakmice
			    </Button.Ripple>
			}
			
		</Card>
	)
}

export default EndGameBar
